import { AfterViewInit, Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { register } from 'swiper/element/bundle';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SettingsService } from "src/app/settings/settings.service";
import { InfoModalOnboarding } from "../info-modal/info-modal";
import { MatTableDataSource } from "@angular/material/table";
import { AgregarFacturas } from "src/app/home/cliente-new-version/agregar-facturas/agregar-facturas";
import { DetalleFacturas } from "src/app/home/cliente-new-version/detalle-facturas/detalle-facturas";
import { AlertDelete } from "src/app/home/cliente-new-version/documentacion/alert-delete/alert-delete";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AddFacturaInfo } from "src/app/home/cliente-new-version/cesion-facturador/add-factura-info/add-factura-info";
import { AgregarCtaComponent } from "./agregar-cta/agregar-cta.component";
import { DeclaracionJuradaComponent } from "./documentos/declaracion-jurada/declaracion-jurada";
import { SituacionFinancieraComponent } from "./documentos/situacion-financiera/situacion-financiera.component";
import { hasData } from "jquery";
import { VisualizarPdfComponent } from "./documentos/visualizar-pdf/visualizar-pdf.component";
import { AgregarFacturasNomina } from "src/app/home/cliente-new-version/agregar-facturas-nomina/agregar-facturas-nomina";
import { FacturasDelSii } from "src/app/home/cliente-new-version/cesion-facturador/facturas-del-sii/facturas-del-sii";
import { CrearSimulacionOnboarding } from "../crear-simulacion/crear-simulacion";

register();

declare var $: any;

interface DocumentConfig {
  displayName: string;
  apiName: string;
  section: string;
  status: {
    hasData: boolean;
    missingFields?: number;
  }
}

@Component({
    selector: 'app-simulacion-automatica',
    templateUrl: './simulacion.html',
    styleUrls: ['./simulacion.less'],
    standalone: false
})
export class SimulacionOnboarding implements OnInit {
  business_name:any=localStorage.getItem('business_name');
  @Input() id_simulation:any;
  accountData: any;
  hasAccounts: boolean | undefined;
  
  totalDocuments: number = 0;
  completedDocuments: number = 0;
  progress: number = 0;

  company_id = localStorage.getItem('company_id');
  isLoading: boolean = true;

  showFinancialStatusCard: any;
  cardMaxWidth: string = '600px';

  @Input() step:any=1;
  @Input() stepper_cuentas: number = 1;
  @Input() clave_unica: any = 0;
  @Input() documentacionStep: number = 1;
  @Input() revisionStep: number = 1;
  @Input() esEmpresaEnUnDia!: boolean;
  @Input() simulacion: number = 0;

  currentStepOnboarding: number = 1;
  

  id_company=localStorage.getItem('company_id');

  valFormNumeroDocumento: FormGroup;
  pinForm: FormGroup;
  current_simulation_id: any;

  constructor(
    public settings: SettingsService, 
    public dialog: MatDialog, 
    public router:Router, 
    private route:ActivatedRoute, 
    private snackBar:MatSnackBar,
    fb: FormBuilder,
  ) { 

    this.route.params.subscribe((params:any) => {

      if(params['id_simulation']){
        this.id_simulation = +params['id_simulation'];
      }

    });

    this.valFormNumeroDocumento = fb.group({
      numeroDocumento: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
    });

    this.pinForm = fb.group({
      pin: ['', [
        Validators.required, 
        Validators.pattern('^[0-9]{4}$'),
        Validators.minLength(4),
        Validators.maxLength(4)
      ]],
    });
  }

  ngOnInit() {
  
    if(this.id_simulation){
      this.get_simulation();
      this.get_facturas();
    }


    this.load_accounts();
    this.get_ejecutivo_dinamico();

    if (this.step == 4){
      this.getDocumentos();
    }

  }

  expandir:boolean=false;
  monto_simulado:any=0;
  porcentaje_financiamiento:any=0;
  monto_anticipo:any=0;
  dias_promedio:any=0;
  loading:boolean=false;
  monto_recibir:any=0;
  tasa_interes:any=0;
  interes_total:any=0;
  comision:any=0;
  gastos:any=0;
  iva_operacion:any=0;
  excedentes:any=0;

  async get_simulation(){
    try {
      this.loading = true;
      const bd: any = await this.settings.get_query(1, `/cliente/simulacion/${this.id_simulation}/`);
      var body_data: any =bd._body;
      switch (bd.status) {
        case 200:

          let sim = body_data.success.info;
          this.monto_simulado = sim.total;
          this.porcentaje_financiamiento = sim.anticipo;
          this.monto_anticipo = sim.valor_anticipo_total;
          this.dias_promedio = sim.dias_promedio;
          this.monto_recibir = sim.monto_recibir;
          this.tasa_interes = sim.tasa_interes;
          this.interes_total = sim.interes_total;
          this.comision = sim.comision;
          this.gastos = sim.gastos;
          this.iva_operacion = sim.iva_operacion;
          this.excedentes = sim.excedentes;

          this.loading = false;

        break;

        default:
        break;
      }

    } catch (bd:any) {
    }
  }

  facturasOriginales: any[] = [];

  onEditSimulation(data: any) {
    console.log('Editando simulación', data);
    console.log('simulationId recibido:', data.id_simulation);
    
    if (data) {
      this.step = 3;
      this.loading_facturas = true;
      
      if (data.simulationId) {
        this.id_simulation = data.simulationId;
        // this.current_simulation_id = data.simulationId;
      }
      
      if (data.fromEdit && data.simulationId) {
        this.get_facturas();
        this.get_simulation();
        
        this.pasoStep3 = true;
        this.cardMaxWidth = '600px';
        
        return;
      }
      
      this.facturasOriginales = [...data.facturas];
      this.simulationData = data.simulation;
      this.postFinalData = data.postFinal;
      
      this.facturas = data.facturas.map((factura: any) => {
        return {
          document: {
            nombre_deudor: factura.deudor || factura.nombre_deudor,
            folio: factura.folio,
            rut_deudor: factura.rut || factura.rut_deudor,
            fecha_documento: factura.fecha_emision || factura.fecha_documento,
            monto_total: factura.monto || factura.monto_total,
            document_factura_id: factura.folio,
          },
          document_simulacion_id: factura.folio,
          isLoading: false
        };
      });
      
      this.monto_simulado = data.simulation.total;
      this.porcentaje_financiamiento = data.simulation.anticipo;
      this.monto_anticipo = data.simulation.valor_anticipo_total;
      this.dias_promedio = data.simulation.dias_promedio;
      this.tasa_interes = data.simulation.tasa_interes;
      this.interes_total = data.simulation.interes_total;
      this.comision = data.simulation.comision;
      this.gastos = data.simulation.gastos;
      this.iva_operacion = data.simulation.iva_operacion;
      this.excedentes = data.simulation.excedentes;
      this.monto_recibir = data.simulation.monto_recibir;
      this.cantidad_facturas = data.facturas.length;
      
      this.pasoStep3 = true;
      this.cardMaxWidth = '600px';
      
      setTimeout(() => {
        this.dataSource = new MatTableDataSource(this.facturas);
        this.dataSource._updateChangeSubscription();
        this.loading_facturas = false;
      }, 100);
    }
  }


  detalle_factura(){
    const dialogRef = this.dialog.open(DetalleFacturas,{
      width: '600px',
      disableClose: true,
      autoFocus: false,
    });
    dialogRef.componentInstance.id_sim = this.id_simulation;

    dialogRef.afterOpened().subscribe(() => {
      dialogRef.componentInstance.get_facturas();
    });
  }

  cantidad_facturas:any=0;
  loading_cantidad:boolean=false;
  pageLength = 0;
  pageSize = 7;
  pageIndex = 0;
  page = 1;
  filtro:any="";
  loading_facturas:boolean=false;

  cantidad_facturas_original:any;
  async get_facturas(){
    try {

      this.loading_facturas = true;
      this.facturas = [];

      const bd: any = await this.settings.get_query(1, '/cliente/simulacion-documentos/'+this.id_simulation+'/?page='+this.page+'&filtro='+this.filtro);
      var body_data: any =bd._body;
      var data = body_data.success;

      switch (bd.status) {
        case 200:
          this.cantidad_facturas = data.total;
          this.facturas = data.info;
          this.loading_facturas = false;

            if (this.cantidad_facturas_original === undefined) {
              this.cantidad_facturas_original = data.total;
            }
          
          setTimeout(() => {
            this.dataSource = new MatTableDataSource(this.facturas);
            this.dataSource._updateChangeSubscription();
          });

        break;
        }
    } catch (bd:any) {

    }
  }

  applyFilter(){
    this.filtro = this.buscar.value;
    this.get_facturas();
  }

  pageEvent(pageNumber: number): void {
    this.page = pageNumber;
    this.get_facturas();
  }

  open_modal_info(step:any, editar?:boolean) {
    if (step === 11) {
      if(editar == false){
      this.open_agregar_facturas_dialog(false);
      } else{
      this.open_agregar_facturas_dialog(true);
      }

      return;
    }

    let dialogRef = this.dialog.open(InfoModalOnboarding, {
      width: '700px',
      autoFocus: false,
    });

    dialogRef.componentInstance.step = step;

    if (step === 17) {
      dialogRef.componentInstance.id_simulation = this.id_simulation;
    }

    dialogRef.afterClosed().subscribe(result => {
      if(result == 'add'){
        //this.open_agregar_facturas();
        this.open_agregar_facturas_dialog();
      }
    });
  }

  home(){
   this.router.navigate(['/home'])
  }

  buscar:any = new FormControl('');
  displayedColumns: string[] = ['deudor', 'factura', 'rut', 'fecha', 'monto', 'accion'];
  ELEMENT_DATA: any[] = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  facturas:any[]=[];
  comenzar_simulacion:boolean=false;

  open_agregar_facturas(){
    const dialogRef = this.dialog.open(AgregarFacturas,{
      width: '530px',
      maxWidth: '95vw',
      disableClose: true,
    });

    dialogRef.componentInstance.agregar_onboarding = true;
    dialogRef.componentInstance.open_as_dialog = true;

    dialogRef.afterClosed().subscribe(result => {
      if(result.length > 0){
        this.comenzar_simulacion = true;
        this.facturas = result;
        this.step = 10;
        this.simulacion = 2;
        console.log(this.facturas)
      }
    });
  }

  open_agregar_facturas_by_nomina(){
    const dialogRef = this.dialog.open(AgregarFacturasNomina,{
      width: '600px',
      disableClose: true,
      maxWidth: '95vw',
      autoFocus:false,
    });

    dialogRef.componentInstance.open_as_dialog = true;

    dialogRef.afterClosed().subscribe(result => {
      if(result.length > 0){
        this.comenzar_simulacion = true;
        this.facturas = result
        this.step = 10;
        this.simulacion = 2;
        console.log(this.facturas)
      }
    });
  }

  async delete_factura(id_factura:any, id_document_simulation:any){
    const elemento = this.facturas.find((el:any) => el.document.document_factura_id === id_factura);

    if (elemento) {
      elemento.isLoading = true;
    }

    try {

      if (this.pasoStep3) {
      this.eliminarFacturaLocal(id_factura);
      return;
    }

      const bd: any = await this.settings.get_query(1, '/cliente/simulacion-validar-delete-folio/'+this.id_simulation+'/?factura='+id_document_simulation, );
      var body_data: any =bd._body;
      var data = body_data.success;
      switch (bd.status) {
        case 200:
        elemento.isLoading = false;

          if(data.info == 3){
            const dialogRef = this.dialog.open(AlertDelete,{
              width: '600px',
              maxWidth: '95vw',
              autoFocus:false,
              disableClose: true,
            });

            dialogRef.componentInstance.id_factura = id_document_simulation;
            dialogRef.componentInstance.id_sim = this.id_simulation;
            dialogRef.componentInstance.titledelete = "¡Estás a punto de eliminar una factura!"
            dialogRef.componentInstance.title = "Si lo haces, será borrada de la"
            dialogRef.componentInstance.subtitle = "operación de forma definitiva."
            dialogRef.componentInstance.deletefacturas = true;
            dialogRef.componentInstance.accion = data.info;

            dialogRef.afterClosed().subscribe((result:any) => {
              if(result == true){
                this.get_simulation();
                this.get_facturas();
                this.step = 1;
              }
            });
          }

          if(data.info == 2){
            const dialogRef = this.dialog.open(AlertDelete,{
              width: '600px',
              maxWidth: '95vw',
              autoFocus:false,
              disableClose: true,
            });

            dialogRef.componentInstance.id_factura = id_document_simulation;
            dialogRef.componentInstance.id_sim = this.id_simulation;
            dialogRef.componentInstance.titledelete = "¡Estás a punto de eliminar una factura importante!"
            dialogRef.componentInstance.title = "Si lo haces, el monto total disminuirá por debajo del <strong>mínimo</strong>"
            dialogRef.componentInstance.subtitle = "<strong>requerido para operar ($3.000.000)</strong> y la simulación será descartada."
            dialogRef.componentInstance.deletefacturas = true;
            dialogRef.componentInstance.accion = data.info;
            dialogRef.componentInstance.onboarding = true;

            dialogRef.afterClosed().subscribe((result:any) => {
              if(result == true){
                this.get_simulation();
                this.get_facturas();
                this.step = 1;
              } else if(result == 'agregar_factura'){
                this.open_modal_info(11);
                this.get_simulation();
                this.get_facturas();
              } else if(result == 'continuar_incorporacion'){
                this.step = 1;
                this.get_simulation();
                this.get_facturas();
              }
            });
          }

          if(data.info == 1){
            const dialogRef = this.dialog.open(AlertDelete,{
              width: '600px',
              maxWidth: '95vw',
              autoFocus:false,
              disableClose: true,
            });

            dialogRef.componentInstance.id_factura = id_document_simulation;
            dialogRef.componentInstance.id_sim = this.id_simulation;
            dialogRef.componentInstance.titledelete = "¡Estás a punto de eliminar tu única factura!"
            dialogRef.componentInstance.title = "Considera que ya no quedarán facturas "
            dialogRef.componentInstance.subtitle = "y la operación será descartada."
            dialogRef.componentInstance.deletefacturas = true;
            dialogRef.componentInstance.accion = data.info;
            dialogRef.componentInstance.onboarding = true;

            dialogRef.afterClosed().subscribe((result:any) => {
              if(result == true){
                this.get_simulation();
                this.get_facturas();
                this.step = 1;
              }
            });
          }



        break;

        default:
        break;
      }

    } catch (bd:any) {
      switch (bd.status) {
        case 500:
            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;

        case 400:
            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;

        default:
            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
        break;
      }
    }
  }

  async delete(id_factura:any, accion:any){
    try {
      const bd: any = await this.settings.get_query(4, '/cliente/simulacion-documentos/'+id_factura+'/?accion='+accion, );
      var body_data: any =bd._body;
      var data = body_data.success;
      switch (bd.status) {
        case 200:
        break;

        default:
        break;
      }

    } catch (bd:any) {

    }
  }

  open_agregar_facturas_dialog(editar?:any){
    const dialogRef = this.dialog.open(AddFacturaInfo,{
      width: '600px',
      maxWidth: '95vw',
      autoFocus:false,
    });

    dialogRef.componentInstance.parent = this;
    dialogRef.componentInstance.id_sim = this.id_simulation;
    dialogRef.componentInstance.step = 2;
    dialogRef.componentInstance.onboarding = true;
    dialogRef.componentInstance.sim_manual = editar;

    dialogRef.afterClosed().subscribe((result:any) => {
      if(result == true || result?.facturas) {
        if (this.id_simulation) {
          this.get_facturas();
          this.get_simulation();
          this.step = 1;
          
          if (this.pasoStep3) {
            setTimeout(() => {
              this.actualizarFacturasOriginalesDesdeFacturas();
            }, 1500);
          }
        } else {
          if (result?.facturas) {
            this.agregarFacturasLocalmente(result.facturas);
          }
        }
      }
    });
  }

  facturas_del_sii(){
    const dialogRef = this.dialog.open(CrearSimulacionOnboarding,{
        width: "1400px",
          autoFocus: false,
    });

    dialogRef.componentInstance.id_sim = this.id_simulation;
    dialogRef.componentInstance.onboarding = true;
    dialogRef.componentInstance.sim_manual = true;


    dialogRef.afterClosed().subscribe((result:any) => {

      if(result.length > 0){
        this.comenzar_simulacion = true;
        this.facturas = result;
        this.step = 10;
        this.simulacion = 2;
        console.log(this.facturas)
      }


    });
  }


  actualizarFacturasOriginalesDesdeFacturas() {
    // Convertir las facturas actuales al formato de facturasOriginales
    this.facturasOriginales = this.facturas.map((factura: any) => {
      return {
        folio: factura.document.document_factura_id,
        rut: factura.document.rut_deudor,
        deudor: factura.document.nombre_deudor,
        monto: factura.document.monto_total,
        fecha_emision: factura.document.fecha_documento
      };
    });

    console.log('✅ facturasOriginales actualizadas desde facturas:', this.facturasOriginales);
    
    // Recalcular monto total
    let suma = 0;
    for (let factura of this.facturasOriginales) {
      suma += Number(factura.monto);
    }
    this.monto_simulado = suma;
  }


  agregarFacturasLocalmente(nuevasFacturas: any[]) {
    for (let factura of nuevasFacturas) {
      const facturaFormateada = {
        document: {
          nombre_deudor: factura.deudor,
          folio: factura.folio,
          rut_deudor: factura.rut,
          fecha_documento: factura.fecha_emision,
          monto_total: factura.monto,
          document_factura_id: factura.folio,
        },
        document_simulacion_id: factura.folio,
        isLoading: false
      };
      
      this.facturas.push(facturaFormateada);
      this.facturasOriginales.push(factura);
    }
    
    // Actualizar la tabla
    this.cantidad_facturas = this.facturas.length;
    this.dataSource = new MatTableDataSource(this.facturas);
    this.dataSource._updateChangeSubscription();
    
    // Recalcular monto total
    let suma = 0;
    for (let factura of this.facturasOriginales) {
      suma += Number(factura.monto);
    }
    this.monto_simulado = suma;
  }


  loading_pdf_:boolean=false;
  async download_pdf(){
    try {
      this.loading_pdf_ = true;

      const bd: any = await this.settings.get_query(1, '/cliente/simulacion-detalle-pdf/'+this.id_simulation+'/', );
      var body_data: any =bd._body;
      var data = body_data;
      switch (bd.status) {
        case 200:
          window.open(data.respuesta.info, "__blank");
          this.loading_pdf_ = false;

        break;

        default:
        break;
      }

    } catch (bd:any) {
      console.log(bd)

      switch (bd.status) {
        case 500:
            this.loading_pdf_ = false;
            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;

        case 400: 
        this.loading_pdf_ = false;
            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;

        default:
          this.loading_pdf_ = false;
            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
        break;
      }
    }
  }

  //Codigo de cuentas bancarias
  isDragOver1 = false;
  isDragOver2 = false;
  uploadedFile1: File | null = null;
  uploadedFile2: File | null = null;
  onDragOver(event: DragEvent, zone: number): void {
    event.preventDefault();
    if (zone === 1) {
      this.isDragOver1 = true;
    } else {
      this.isDragOver2 = true;
    }
  }

  onDragLeave(zone: number): void {
    if (zone === 1) {
      this.isDragOver1 = false;
    } else {
      this.isDragOver2 = false;
    }
  }

  onFileDrop(event: DragEvent, zone: number): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files?.length) {
      this.assignFile(files[0], zone);
    }
    this.onDragLeave(zone);
  }

  onFileSelect(event: Event, zone: number): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.assignFile(input.files[0], zone);
    }
  }

  triggerFileInput(zone: number): void {
    const fileInput = document.getElementById(`fileInput${zone}`) as HTMLElement;
    fileInput.click();
  }

  assignFile(file: File, zone: number): void {
    if (zone === 1) {
      this.uploadedFile1 = file;
    } else if (zone === 2) {
      this.uploadedFile2 = file;
    }
  }

  subir_archivos(){
    console.log(this.uploadedFile1)
    console.log(this.uploadedFile2)
  }
  
  async load_accounts() {
    this.isLoading = true;
    try {
      const body_data: any = await this.settings.get_query(1, `/cuentasAcreedoresBank/${this.id_company}/`)
      const _body = body_data._body

      this.accountData = _body.accounts && _body.accounts.length > 0 ? _body.accounts[0] : null;
      this.hasAccounts = _body.accounts && _body.accounts.length > 0;

      const primaryAccount = _body.accounts?.find((account: { is_primary: any; }) => account.is_primary);
      const accountIdToEdit = primaryAccount?.id;
    
    } catch (bd:any) {
      this.accountData = null; 
      this.hasAccounts = false;
    } finally {
      this.isLoading = false;
    }
  }
  
  agregarCuentaBancaria(){
    const dialogRef = this.dialog.open(AgregarCtaComponent,{
      width: '500px',
      maxWidth: '95vw',
      autoFocus:false,
      height: 'auto',
      maxHeight: '95vh',
    });
    
    dialogRef.afterClosed().subscribe(result => {
      this.load_accounts();
    });
  }

  editarCuentaBancaria(id: any) {
    const primaryAccount = this.accountData;
    const dialogRef = this.dialog.open(AgregarCtaComponent, {
      width: '500px',
      maxWidth: '95vw',
      autoFocus: false,
      height: 'auto',
      maxHeight: '95vh',
      data: primaryAccount
    });

    dialogRef.afterClosed().subscribe(result => {
      this.load_accounts();
    });
  }

  readonly  document_config: { [key: string]: DocumentConfig } = {
    declaracionJurada: {
      displayName: 'Declaración jurada',
      apiName: 'declaracion_jurada',
      section: 'Documentos legales',
      status: { hasData: false, missingFields: 4 }
    },
    declaracionPep: {
      displayName: 'Declaración PEP',
      apiName: 'declaracion_PEP',
      section: 'Documentos legales',
      status: { hasData: true }
    },
    estadoSituacionFinanciera: {
      displayName: 'Estado de situación financiera',
      apiName: 'estado_situacion',
      section: 'Documentos legales',
      status: { hasData: false, missingFields: 3 }
    },
    rolAvalista: {
      displayName: 'Rol de avalista',
      apiName: 'rol_avalista',
      section: 'Documentos legales',
      status: { hasData: true }
    },
    cartaPoder: {
      displayName: 'Carta de poder',
      apiName: 'carta_poder',
      section: 'Poderes legales',
      status: { hasData: false }
    },
    poderNotarial: {
      displayName: 'Poder notarial',
      apiName: 'poder_notarial',
      section: 'Poderes legales',
      status: { hasData: false }
    },
    poderesBancarios: {
      displayName: 'Poderes bancarios',
      apiName: 'poderes_bancarios',
      section: 'Poderes legales',
      status: { hasData: false }
    },
    contrato: {
      displayName: 'Contrato',
      apiName: 'contrato',
      section: 'Contrato',
      status: { hasData: true }
    }
  };


  getStatusText(documentKey: string): string {
    const status = this.document_config[documentKey].status;
    if (status.hasData) return 'Completado';
    if (status.missingFields) {
      return status.missingFields === 1 
        ? 'Falta 1 dato'
        : `Faltan ${status.missingFields} datos`;
    }
    return 'Pendiente';
  }


  capitalizeText(text: string): string {
    return text.toLowerCase().split(' ').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
  }
  
  hasPendingDocuments(): boolean {
    const evaluateDocuments = [
      this.document_config["declaracionJurada"],
      this.document_config["estadoSituacionFinanciera"]
    ];
  
    const completeDocuments = evaluateDocuments.some(doc => !doc.status.hasData);
    const poderesLegalesDocuments = [
      this.document_config["cartaPoder"],
      this.document_config["poderNotarial"],
      this.document_config["poderesBancarios"]
    ];
  
    const poderesLegales = poderesLegalesDocuments.some(doc => doc.status.hasData);
    if (poderesLegales) {
      const selectedPoderLegal = poderesLegalesDocuments.find(doc => doc.status.hasData);
      return !selectedPoderLegal?.status.hasData || completeDocuments;
    }
  
    return completeDocuments;
  }

  titleText: string = 'completa la documentación legal con los datos que faltan';
  subtitleText: string = '';  

  calculateProgress() {
    const alwaysCompleted = [
      this.document_config["rolAvalista"],
      this.document_config["declaracionPep"],
      this.document_config["contrato"]
    ];

    const evaluateDocuments = [
      this.document_config["declaracionJurada"],
      this.document_config["estadoSituacionFinanciera"]
    ];

    const poderesLegalesDocuments = [
      this.document_config["cartaPoder"],
      this.document_config["poderNotarial"],
      this.document_config["poderesBancarios"]
    ].filter(doc => doc.status.hasData);

    const documentsToCount = [...alwaysCompleted, ...evaluateDocuments, ...poderesLegalesDocuments];

    this.totalDocuments = documentsToCount.length;
    this.completedDocuments = documentsToCount.filter(doc => doc.status.hasData).length;
    this.progress = Math.round((this.completedDocuments / this.totalDocuments) * 100);

    if (this.progress === 100) {
      this.titleText = 'la documentación legal que debes firmar fue autocompletada';
      this.subtitleText = 'Puedes revisar y descargar los documentos antes de firmarlos.';
    }

    console.log('Document completion status:');
    documentsToCount.forEach(doc => {
      console.log(`${doc.displayName}: ${doc.status.hasData}`);
    });
    console.log(`Total documents: ${this.totalDocuments}, Completed: ${this.completedDocuments}`);
  }

  situacionFinancieraView: any = 1;
  handleDocumentClick(documentKey: string, action: string): void {
    if (action === 'view') {
      if (documentKey === 'estadoSituacionFinanciera' && !this.document_config[documentKey].status.hasData) {
        this.step = 5;
        this.situacionFinancieraView = 1;
      } else {
        this.openDocumentDialog(documentKey);
      }
    } else if (action === 'download') {
      this.downloadDocument(documentKey);
    }
  }
  

  openDocumentDialog(documentKey: string) {
    const document = this.document_config[documentKey];
    let componentToOpen: any;
    let shouldRefresh = true;
  
    if (
      !document.status.hasData && 
      (document.displayName === 'Declaración jurada' || document.displayName === 'Estado de situación financiera')
    ) {
      componentToOpen = document.displayName === 'Declaración jurada' ? 
      DeclaracionJuradaComponent : 
      SituacionFinancieraComponent;
    } else {
      componentToOpen = VisualizarPdfComponent;
      shouldRefresh = false;
    }
  
    const dialogRef = this.dialog.open(componentToOpen, {
      width: '600px',
      maxWidth: '100vw',
      autoFocus: false,
      height: 'auto',
      maxHeight: '100vh',
      data: {
        documentType: document.displayName,
      },
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (shouldRefresh || result === true) {
        this.getDocumentos();
      }
    });
  
    console.log('Documento abierto:', document.displayName);
  }
  

  async downloadDocument(documentKey: string) {
    this.isLoading = true;
    const document = this.document_config[documentKey];

    try {
        const response: any = await this.settings.get_query(1, `/onboarding/data-onboarding/${this.company_id}/?type_document=${document.apiName}`);
        const url = response._body.success.url;
        window.open(url, '_blank');

    } catch (error) {
      console.error('Error al descargar ', document.displayName, ' :', error);
      this.snackBar.open('Error al descargar el documento', 'X', {
          duration: 20000,
          panelClass: 'simpli-snack-error'
      });
    } finally {
        this.isLoading = false;
    }
  }

  dialogSituacionFinanciera(): void {
    this.stepper_cuentas = 2;
    this.step = 4;
    this.openDocumentDialog('estadoSituacionFinanciera');
  }
  
  

  pendingDocs: number = 0;
  async verDocumentos() {
    if (this.hasAccounts) {
      await this.getDocumentos();

      this.pendingDocs = (
        (this.document_config["declaracionJurada"].status.missingFields || 0) +
        (this.document_config["estadoSituacionFinanciera"].status.missingFields || 0)
      );
      console.log('Pending Count:', this.pendingDocs);


      if (this.pendingDocs === 0) {
        this.step = 4;
        this.stepper_cuentas = 2;
        this.getDocumentos();
      } else {
        this.step = 2;
      }
    } else {
      this.step = 4;
      this.stepper_cuentas = 2;
      this.getDocumentos();
    }
  }




  async getDocumentos() {
    this.isLoading = true;
    try {
      const response: any = await this.settings.get_query(1, `/onboarding/data-onboarding/${this.company_id}/`);
      const documentData = response._body.success.info.set_documentos;

      const set1 = documentData.set1;
      this.statusDeclaracionJurada(set1.declaracion_jurada);
      this.statusSituacionFinanciera(set1.informacion_financiera);

      const set2 = documentData.set2;
      this.document_config["cartaPoder"].status.hasData = !!set2?.carta_poder?.link;
      this.document_config["poderNotarial"].status.hasData = !!set2?.poder_notarial?.link;
      this.document_config["poderesBancarios"].status.hasData = !!set2?.poderes_bancarios?.link;

      this.calculateProgress();

    } catch (error) {
      console.error('Error al obtener documentos:', error); 

      // this.document_config["declaracionJurada"].status = {
      //   hasData: false,
      //   missingFields: 4
      // };
    
      // this.document_config["estadoSituacionFinanciera"].status = {
      //     hasData: false,
      //     missingFields: 3
      // };

      // this.calculateProgress();
    } finally {
      this.isLoading = false;
    }
  }

  statusDeclaracionJurada(declaracionJurada: any) {
    let missingCount = 0;
    const sections = ['antecedentes_declarante', 'beneficiarios_finales', 'control_efectivo', 'persona_natural'];

    const hasAntecedentes = !!(
      declaracionJurada.antecedentes_declarante?.domicilio?.direccion &&
      declaracionJurada.antecedentes_declarante?.domicilio?.comuna &&
      declaracionJurada.antecedentes_declarante?.domicilio?.ciudad &&
      declaracionJurada.antecedentes_declarante?.telefono
    );
    if (!hasAntecedentes) missingCount++;

    const hasBeneficiarios = !!(declaracionJurada.beneficiarios_finales?.length);
    if (!hasBeneficiarios) missingCount++;

    const hasControl = !!(declaracionJurada.control_efectivo?.length);
    if (!hasControl) missingCount++;

    const hasPersonaNatural = !!(declaracionJurada.persona_natural?.relacion_pj_declarante);
    if (!hasPersonaNatural) missingCount++;

    this.document_config["declaracionJurada"].status = {
      hasData: missingCount === 0,
      missingFields: missingCount
    };
  }

  statusSituacionFinanciera(situacionFinanciera: any) {
    let missingCount = 0;
    const sections = ['antecedentes_personales', 'antecedentes_conyuge', 'antecedentes_comerciales'];

    const hasAntecedentesPersonales = !!(
      situacionFinanciera.antecedentes_personales?.direccion && 
      situacionFinanciera.antecedentes_personales?.comuna && 
      situacionFinanciera.antecedentes_personales?.ciudad && 
      situacionFinanciera.antecedentes_personales?.telefono && 
      situacionFinanciera.antecedentes_personales?.profesion 
    );
    if (!hasAntecedentesPersonales) missingCount++;

    const hasAntecedentestecedentes = !!(
      situacionFinanciera.antecedentes_conyuge?.nacionalidad &&
      situacionFinanciera.antecedentes_conyuge?.profesion &&
      situacionFinanciera.antecedentes_conyuge?.empleador 
    );
    if (!hasAntecedentestecedentes) missingCount++;

    const hasAntecedentesComerciales = !!(situacionFinanciera.antecedentes_comerciales?.length);
    if (!hasAntecedentesComerciales) missingCount++;

    this.document_config["estadoSituacionFinanciera"].status = {
      hasData: missingCount === 0,
      missingFields: missingCount
    };
  }

  hasDocumentsInSection(section: string): boolean {
    return Object.values(this.document_config).some(doc => doc.section === section);
  }
  
  getDocumentsBySection(section: string): string[] {
    return Object.keys(this.document_config).filter(key => {
      const doc = this.document_config[key];
      if (doc.section === section) {
        if (section === 'Poderes legales') {
          return doc.status.hasData;
        }
        return true;
      }
      return false;
    });
  }
  
  shouldShowSection(section: string): boolean {
    if (section === 'Poderes legales') {
      const poderesLegalesDocs = [
        this.document_config["cartaPoder"],
        this.document_config["poderNotarial"],
        this.document_config["poderesBancarios"]
      ];
      return poderesLegalesDocs.some(doc => doc.status.hasData);
    }
    return true;
  }

  registrarCuenta() {
    this.step = 4; 
    this.stepper_cuentas = 1;

    this.load_accounts();

    // this.router.navigate(['home/']);
  }

  volverDesdeRegistro() {
    this.step = 2;
    this.pendingDocs = 0;
  }

  volverDesdeDocumentacion() {
    this.step = 2

    if(this.pendingDocs === 0) {
      this.step = 4;
      this.stepper_cuentas = 1;
      this.load_accounts()
    }
  }

  loading_name: boolean = false;
  name: string = '';
  async get_ejecutivo_dinamico() {
    this.loading_name = true;
    try {
      const bd: any = await this.settings.get_query(1, `/cliente/ejecutivo-representante-empresa/` + this.id_company + '/');
      var body_data: any = bd._body;
      switch (bd.status) {
        case 200:
          this.name =  body_data.success.info.nombre;
          this.loading_name  = false;
          break;

        default:
          break;
      }
    } catch (bd: any) {
    } finally {
      this.loading_name = false;
    }
  } 

  selectedFile: File | null = null;
  isFileSelected: boolean = false;  
  selectedFileName: string = '';

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.type === 'application/pdf' || file.type.startsWith('image/jpeg')) {
        if (file.size <= 50 * 1024 * 1024) {
          this.selectedFile = file;
          this.isFileSelected = true;
          this.selectedFileName = file.name;
        } else {
          this.snackBar.open('El archivo excede el tamaño máximo de 50MB', 'Cerrar', {
            duration: 3000,
            panelClass: 'simpli-snack-onboarding'
          });
        }
      } else {
        this.snackBar.open('Solo se admiten archivos PDF o JPG', 'Cerrar', {
          duration: 3000,
          panelClass: 'simpli-snack-onboarding'
        });
      }
    }
  }

  clearSelectedFile() {
    this.selectedFile = null;
    this.isFileSelected = false;
  }

  claveUnicaUrl: string = '';
  code: string = '';
  async loginClaveUnica() {
    try {
      this.stepper_cuentas = 3;
      this.clave_unica = 1;

      const body = {
        successRedirect: "https://www.google.com",
        failedRedirect: "https://www.esign-la.com/"
      };

      const bd: any = await this.settings.get_query(2, `/onboarding/tokens-request/`, body);
      var body_data: any = bd._body;

      if (body_data.success && body_data.success.ok === true)  {

        this.code = body_data.success.info.code;

        const authResponse: any = await this.settings.get_query(2, `/onboarding/tokens-authorize/${this.code}/`);
        const authData: any = authResponse._body;

        if (authData.success && authData.success.ok === true) {
          this.claveUnicaUrl = authData.success.info.url;
          console.log("URL de ClaveUnica:", this.claveUnicaUrl);
          

          this.autenticarConClaveUnica();


        }
      }
    } catch (bd: any) {
      console.error("Error al solicitar token:", bd);
    }
  }

  accessToken: string = '';
  async autenticarConClaveUnica() {
    try {
      const popupWindow = window.open(
        this.claveUnicaUrl,
        'ClaveUnicaWindow',
        `width=800,height=800,left=200,top=100,resizable=yes,scrollbars=yes,status=yes`
      );
      
      if (!popupWindow || popupWindow.closed || typeof popupWindow.closed === 'undefined') {
        const snackBarRef = this.snackBar.open(
          'Para continuar, debe habilitar las ventanas emergentes en tu navegador',
          'X',
          {
            duration: 0,
            panelClass: 'simpli-snack-onboarding'
          }
        );
        
        snackBarRef.onAction().subscribe(() => {
          this.autenticarConClaveUnica();
        });
        
        return;
      }
      
      this.snackBar.dismiss();
      
    } catch (error) {
      console.error("Error en autenticarConClaveUnica:", error);
      this.snackBar.open('Error al iniciar la autenticación', 'X', {
        duration: 5000,
        panelClass: 'simpli-snack-onboarding'
      });
    }
  }

  async checkToken() {
    try {
      const bd: any = await this.settings.get_query(1, `/onboarding/tokens-authorize/${this.code}/`);
      var body_data: any = bd._body;
      
      if (body_data?.success?.info) {
        this.accessToken = body_data.success.info.accessToken;
        
        if (this.accessToken && this.accessToken.trim() !== '') {
          console.log("Token recibido correctamente:", this.accessToken);
          this.challengeClaveUnica();
          this.stepper_cuentas = 3;
          this.clave_unica = 2;
          return;
        }
      }
      
      this.snackBar.open('No se detectó autenticación con Clave Única. Vuelva a intentarlo.', 'X', {
        duration: 5000,
        panelClass: 'simpli-snack-onboarding'
      });
      this.loginClaveUnica();
      
    } catch (error) {
      console.error("Error al verificar el token:", error);
      this.snackBar.open('Ocurrió un error al verificar Clave Única. Por favor, intente nuevamente.', 'X', {
        duration: 5000,
        panelClass: 'simpli-snack-onboarding'
      });
      this.loginClaveUnica();
    }
  }
  
  
  async challengeClaveUnica() {
    try {
      const bd: any = await this.settings.get_query(1, `/onboarding/challenge-generar-token/`);
      var body_data: any = bd._body;

      // if (body_data?.success?.info) {
      //   const token = body_data.success.info.token;
      // }

    } catch (error) {
      
    }
  }
  
  async startChallenge() {
    try {
      const body = {
        rut: "26959883-2",
        numeroDocumento: this.valFormNumeroDocumento.value.numeroDocumento,
        nombre: "Maria Carmen de los Angeles",
        apellidoPaterno: "Del rio",
        apellidoMaterno: "Gonzalez",
        email: "maria.delrio@gmail.com",
        fechaNacimiento: "1990-01-01",
        estadoCivil: "Soltero",
        telefono: "987654321",
        token: "1234567890",
      }

      const bd: any = await this.settings.get_query(1, `/onboarding/challenge-ingreso-validacion/`, body);
      var body_data: any = bd._body;
    } catch (error) {
      
    }
  }

  
  preventSpaces(event: KeyboardEvent): void {
    if (event.key === ' ' || event.code === 'Space') {
      event.preventDefault();
    }
  }
  

  questionData = {
    "preguntas": [
      {
        "id": "1",
        "descripcion": "¿En qué mes nació su padre?",
        "alternativas": [
          {
            "id": "1",
            "descripcion": "JULIO"
          },
          {
            "id": "2",
            "descripcion": "FEBRERO"
          },
          {
            "id": "3",
            "descripcion": "AGOSTO"
          },
          {
            "id": "4",
            "descripcion": "DICIEMBRE"
          },
          {
            "id": "5",
            "descripcion": "NINGUNA DE LAS ANTERIORES"
          }
        ]
      },
      {
        "id": "2",
        "descripcion": "¿En cuál de las siguientes regiones cursó Educación básica o media el año 2007?",
        "alternativas": [
          {
            "id": "1",
            "descripcion": "DE LA ARAUCANIA"
          },
          {
            "id": "2",
            "descripcion": "METROPOLITANA DE SANTIAGO"
          },
          {
            "id": "3",
            "descripcion": "DE VALPARAISO"
          },
          {
            "id": "4",
            "descripcion": "DE MAGALLANES Y ANTARTICA CHILENA"
          },
          {
            "id": "5",
            "descripcion": "NINGUNA DE LAS ANTERIORES"
          }
        ]
      },
      {
        "id": "3",
        "descripcion": "¿Cuál es el segundo apellido de tu abuelo paterno?",
        "alternativas": [
          {
            "id": "1",
            "descripcion": "RIVERA"
          },
          {
            "id": "2",
            "descripcion": "VIDAL"
          },
          {
            "id": "3",
            "descripcion": "PIÑERA"
          },
          {
            "id": "4",
            "descripcion": "GONZALEZ"
          },
          {
            "id": "5",
            "descripcion": "NINGUNA DE LAS ANTERIORES"
          }
        ]
      },
      {
        "id": "4",
        "descripcion": "¿En qué ciudad naciste?",
        "alternativas": [
          {
            "id": "1",
            "descripcion": "SANTIAGO"
          },
          {
            "id": "2",
            "descripcion": "VALPARAISO"
          },
          {
            "id": "3",
            "descripcion": "CONCEPCION"
          },
          {
            "id": "4",
            "descripcion": "TEMUCO"
          },
          {
            "id": "5",
            "descripcion": "NINGUNA DE LAS ANTERIORES"
          }
        ]
      }
    ]
  };

  selectedRadioValue: number | null = null;
  currentQuestion: number = 0;
  selectedAnswers: {[key: string]: string} = {};

  parseInt(value: string): number {
    return parseInt(value);
  }

  onRadioChange(questionId: string, answerId: string): void {
    this.selectedAnswers[questionId] = answerId;
    this.selectedRadioValue = parseInt(answerId);
  }

  isAnswerSelected(): boolean {
    const currentQuestionId = this.questionData.preguntas[this.currentQuestion].id;
    return !!this.selectedAnswers[currentQuestionId];
  }

  getFormattedAnswers() {
    const respuestas = Object.keys(this.selectedAnswers).map(questionId => {
      return {
        "pregunta": parseInt(questionId),
        "respuesta": parseInt(this.selectedAnswers[questionId])
      };
    });
    
    return { "respuestas": respuestas };
  }

  nextQuestion() {
    if (this.currentQuestion < this.questionData.preguntas.length - 1) {
      const currentQuestionId = this.questionData.preguntas[this.currentQuestion].id;
      if (this.selectedRadioValue !== null) {
        this.selectedAnswers[currentQuestionId] = this.selectedRadioValue.toString();
      }
      
      this.currentQuestion++;
      
      this.selectedRadioValue = null;
      
      const nextQuestionId = this.questionData.preguntas[this.currentQuestion].id;
      if (this.selectedAnswers[nextQuestionId]) {
        this.selectedRadioValue = parseInt(this.selectedAnswers[nextQuestionId]);
      }
    } else {
      const currentQuestionId = this.questionData.preguntas[this.currentQuestion].id;
      if (this.selectedRadioValue !== null) {
        this.selectedAnswers[currentQuestionId] = this.selectedRadioValue.toString();
      }
      
      const answersData = this.getFormattedAnswers();
      console.log('Enviando respuestas al backend:', answersData);
      this.stepper_cuentas = 3;
      this.clave_unica = 3;
    }
  }
  
  previousQuestion() {
    if (this.currentQuestion > 0) {
      this.currentQuestion--;
      const questionId = this.questionData.preguntas[this.currentQuestion].id;
      this.selectedRadioValue = this.selectedAnswers[questionId] ?
        parseInt(this.selectedAnswers[questionId]) : null;
    } else {
      this.selectedRadioValue = null;
      this.selectedAnswers = {};
      this.currentQuestion = 0;
  
      this.stepper_cuentas = 3;
      this.clave_unica = 1;
    }
  }

  capitalizeTextQuestion(text: string): string {
    const lowercaseWords = ['e', 'y', 'de', 'la', 'el', 'los', 'las', 'del', 'al', 'a', 'con', 'en', 'por', 'para', 'su', 'sus'];
    
    return text.toLowerCase().split(' ').map((word, index) => {
      if (lowercaseWords.includes(word) && index !== 0) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  }
  totalQuestions(): number {
    return this.questionData.preguntas.length;
  }

  progressSteps(): number[] {
    return Array(this.questionData.preguntas.length).fill(0);
  }

  // geolocalizacion
  isGeolocationEnabled: boolean = false;
  userLocation: any = null;

  onGeolocationToggle(event: any): void {
    if (this.isGeolocationEnabled) {
      this.getGeolocation();
    } else {
      console.log('Geolocalización desactivada');
      this.userLocation = null;
    }
  }

  getGeolocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.userLocation = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
          console.log('Geolocalización activada:', this.userLocation);
          this.getAddressFromCoordinates(position.coords.latitude, position.coords.longitude);
        },
        (error) => {
          console.error('Error al obtener la ubicación:', error);
          
        }
      );
    } else {
      this.isGeolocationEnabled = false;
    }
  }

  getAddressFromCoordinates(latitude: number, longitude: number): void {
    console.log(`Coordenadas: ${latitude}, ${longitude}`);
  }

  showPin: boolean = false;
  get eyeIconClass(): string {
    return this.showPin ? 'visibility' : 'visibility_off';
  }
  
  togglePinVisibility() {
    this.showPin = !this.showPin;
  }

  validarNumeroPin(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  navigateToHome() {
    this.router.navigate(['home/']);
  }

  go_to_simular() {
    this.comenzar_simulacion = true;
    this.simulacion = 2;
  }

  simulationData: any = null;
  postFinalData: any = null;
  pasoStep3: boolean = false;
  vieneDeAprobacion: boolean = false;

  onSimulationCompleted(data: any) {
    this.cardMaxWidth = '600px';

    this.step = 10;
    this.simulacion = 3; 
    this.pasoStep3 = false;
  }

  volver_desde_start_simulation(){
    this.step = 10;
    this.simulacion = 1;
    this.cardMaxWidth = '600px'; 
    this.comenzar_simulacion = false;
    this.facturas = [];
    this.simulationData = null;
    this.postFinalData = null;
  }

  onStepChanged(step: number) {
    if (step === 2) {
      this.step = 2;
      this.vieneDeAprobacion = true;
    } else if (step === 3) {
      this.simulacion = 3;
    }
  }



  


  // volverAlResumen() {
  //   this.step = 10;
  //   this.simulacion = 3;
  //   this.pasoStep3 = false;
    
  //   this.facturas = [...this.facturasOriginales];

  //   this.cardMaxWidth = '600px';
  //   this.comenzar_simulacion = true;
  // }

  eliminarFacturaLocal(id_factura: any) {
    const index = this.facturas.findIndex((factura: any) => 
      factura.document.document_factura_id === id_factura
    );

    if (index > -1) {
      this.facturas.splice(index, 1);
      
      const indexOriginal = this.facturasOriginales.findIndex((factura: any) => 
        factura.folio === id_factura
      );
      if (indexOriginal > -1) {
        this.facturasOriginales.splice(indexOriginal, 1);
      }

      this.cantidad_facturas = this.facturas.length;
      
      let suma = 0;
      for (let factura of this.facturasOriginales) {
        suma += Number(factura.monto);
      }
      this.monto_simulado = suma;

      setTimeout(() => {
        this.dataSource = new MatTableDataSource(this.facturas);
        this.dataSource._updateChangeSubscription();
      });

    }


  }

  volverASimulacion() {
    this.loading = true;
    this.step = 1;
    
    this.get_simulation();
    this.get_facturas();
  }

  onCardWidthChange(width: string) {
    this.cardMaxWidth = width;
  }


  changeStepOnboarding(step: number) {
    this.currentStepOnboarding = step;
    
    // Sincronizar con el componente hijo
    if (this.currentStepOnboarding === 1) {
      // Forzar que el componente hijo vaya al step 1
      this.onStepStateChangedOnboarding(1);
    } else if (this.currentStepOnboarding === 2) {
      // Forzar que el componente hijo vaya al step 2
      this.onStepStateChangedOnboarding(2);
    }
  }

  onStepStateChangedOnboarding(step: number) {
    this.currentStepOnboarding = step;
    
    // Actualizar clases CSS del stepper
    const steppers = document.querySelectorAll('.stepper-simpli');
    steppers.forEach(stepper => stepper.classList.remove('stepper-simpli-active'));
    
    if (step === 1) {
      const step1 = document.getElementById('step-simpli1-onboarding');
      if (step1) step1.classList.add('stepper-simpli-active');
    } else if (step === 2) {
      const step2 = document.getElementById('step-simpli2-onboarding');
      if (step2) step2.classList.add('stepper-simpli-active');
    }
  }

  mostrar_volver:boolean=false;

}